import { useContext } from 'react';
import {
    Typography, Card, CardContent, TablePagination, Table,
    TableHead, TableBody, TableRow, TableCell, makeStyles, Theme, useTheme,
    Tooltip, Zoom, IconButton, Grid, Link, TableFooter, colors
} from '@material-ui/core';
import { dealersContext } from '../DealersContext';
import { FaFileExcel } from 'react-icons/fa';
import { FiFileText } from 'react-icons/fi';
import { CircleLoader, DeleteIconButton, EditIconButton, ExcelImport } from 'components';
import { applicationContext, appUserContext } from 'helpers/services';


let useStyles = makeStyles((theme: Theme) => ({
    root: {
        marginTop: theme.spacing(3)
    },
    content: {
        padding: 0
    }
}))

let Results = () => {
    let theme = useTheme();
    let classes = useStyles(theme);

    let { currentUser } = useContext(appUserContext);
    let appService = useContext(applicationContext);
    let service = useContext(dealersContext);


    return (
        <div className={classes.root}>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="subtitle2">
                                {service.recordCount} dealers found
                            </Typography>
                        </Grid>
                        {service.recordCount > 0 &&
                            <Grid item>
                                {currentUser?.isSuperAdmin === true && <ExcelImport />}
                                <Tooltip TransitionComponent={Zoom} title={'Export as Excel file'}>
                                    <IconButton size="small" onClick={service.downloadAsExcel}>
                                        <FaFileExcel color={colors.green[600]} size={24} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip TransitionComponent={Zoom} title={'Export as txt file'}>
                                    <IconButton size="small" onClick={service.downloadAsText}>
                                        <FiFileText color={colors.grey[600]} size={24} />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        }
                    </Grid>

                    <Card>
                        <CardContent className={classes.content}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Dealer</TableCell>
                                        <TableCell>Contact Info</TableCell>
                                        <TableCell>Type</TableCell>
                                        <TableCell>Brands</TableCell>
                                        <TableCell>Program</TableCell>
                                        <TableCell>Geolocation</TableCell>
                                        <TableCell align="right" />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {service.dealers.map(dealer => (
                                        <TableRow hover key={dealer.dealerId}>
                                            <TableCell>
                                                <b>{dealer.name}</b>{dealer.extId && <>&nbsp;({dealer.extId})</>}
                                                <Typography variant="subtitle1">{dealer.address}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                {dealer.phone &&
                                                    <>PH:&nbsp;<Typography component="span" variant="subtitle1">{dealer.phone}</Typography><br /></>
                                                }
                                                {dealer.email && <>{dealer.email}<br /></>}
                                                {dealer.website &&
                                                        <Link target="_blank"
                                                            href={dealer.website.indexOf("https") === -1 ? `https://${dealer.website}/` : dealer.website}
                                                        >
                                                            {dealer.website}
                                                        </Link>
                                                }
                                            </TableCell>
                                            <TableCell>
                                                {dealer.isDealer && !dealer.isDistributor && <span>Dealer</span>}
                                                {!dealer.isDealer && dealer.isDistributor && <span>Distributor</span>}
                                                {dealer.isDealer && dealer.isDistributor && <span>Dealer/Distributor</span>}
                                                <Typography variant="subtitle1">source:&nbsp;{dealer.source}</Typography>
                                            </TableCell>
                                            <TableCell>{dealer.brands.map(brand => appService.referenceData.brands.getValueByKey(brand)).join(", ")}</TableCell>
                                            <TableCell>{dealer.programs.map(x => x.name).join(", ")}</TableCell>
                                            <TableCell>
                                                Lat:&nbsp;<Typography component="span" variant="subtitle1">{dealer.lat}</Typography><br />
                                                Lng:&nbsp;<Typography component="span" variant="subtitle1">{dealer.lng}</Typography>
                                            </TableCell>
                                            <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
                                                {dealer.canManageDealer &&
                                                    <>
                                                        <EditIconButton link={`/dealer/edit/${dealer.dealerId}`} />
                                                        <DeleteIconButton onClick={() => service.deleteDealer(dealer.dealerId)} />
                                                    </>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                                {service.dealers.length === 0 &&
                                    <TableFooter>
                                        <TableRow>
                                            <TableCell colSpan={7}>
                                                <Typography variant="subtitle1">No dealers found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>
                                }
                            </Table>
                            <TablePagination
                                component="div"
                                count={service.recordCount}
                                onPageChange={service.handleChangePage}
                                page={service.search.pageNr}
                                rowsPerPage={service.search.pageSize}
                                rowsPerPageOptions={[service.search.pageSize]}
                                labelDisplayedRows={({ page, count }) =>
                                    <span>Page {page + 1} of {Math.ceil(count / service.search.pageSize)}</span>
                                }
                            />
                        </CardContent>
                    </Card>
                </>
            }
        </div>
    )
}

export default Results;